import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--bookings--day"
export default class extends Controller {
  static targets = [
    "noBookings",
    "booking",
    "timeslot"
  ]

  connect() {
    this.init()
  }

  init() {
    this.checkBookingsCount()

    let timeslot = this.timeslotTargets.filter((slot) => {
      return slot.dataset.hour === "07:00"
    })

    timeslot[0].scrollIntoView({ behavior: "instant", block: "start" })
  }

  checkBookingsCount() {
    if (this.bookingTargets.length === 0) {
      this.noBookingsTarget.classList.remove("hidden")
    }
  }

  bookingTargetConnected(booking) {
    this.noBookingsTarget.classList.add("hidden")

    this.waitForElementsReady(booking).then(() => {
      booking.style.top = this.getTimeslotPosition(booking.dataset.appointment) + 8 + "px"
    })
  }

  waitForElementsReady(booking) {
    return new Promise((resolve) => {
      const checkReady = () => {
        // Check if timeslots exist and the specific appointment timeslot is available
        const appointmentTime = booking.dataset.appointment
        const targetTimeslot = this.timeslotTargets.find(slot => slot.dataset.hour === appointmentTime)

        if (targetTimeslot && targetTimeslot.offsetTop > 0) {
          resolve()
        } else {
          requestAnimationFrame(checkReady)
        }
      }

      // Start checking after next frame to ensure DOM is updated
      requestAnimationFrame(checkReady)
    })
  }

  bookingTargetDisconnected() {
    if (this.bookingTargets.length === 0) {
      this.noBookingsTarget.classList.remove("hidden")
    }
  }

  getTimeslotPosition(appointment) {
    let slot

    this.timeslotTargets.forEach((timeslot) => {
      if (timeslot.dataset.hour === appointment) { slot = timeslot.offsetTop }
    })

    return slot
  }
}
